import { useEffect, useState } from 'react'
import ModalComponent from '..'
import { PRIMARY_COLOR } from '../../../constants'
import { useGetAllProductTagsQuery } from '../../../redux-toolkits/products/products.slice'
import { Tag } from '../../../redux-toolkits/products/products.type'
import { QueryProps } from '../../../redux-toolkits/shared/shared.type'
import { Button } from '../../button'
import { EmptyState } from '../../emptyState/emptyState'
import { Checkbox } from '../../inputs/Checkbox'
import { SearchInput } from '../../inputs/searchInput'
import { LoadingOval } from '../../spinner/Spinner'

const defaultquery = {
  search: undefined,
  skip: 0,
  limit: '100',
}

export const SelectTagsModal = ({
  open,
  setOpen,
  onCloseCallback,
  onSuccessCallback,
  selectedTags = [],
}: {
  open: boolean
  setOpen: (val: boolean) => void
  onCloseCallback?: () => void
  onSuccessCallback?: (val: Tag[]) => void
  selectedTags?: Tag[]
}) => {
  const [queryParam, setQueryParam] = useState<QueryProps>(defaultquery)

  const [tags, setTags] = useState<Tag[]>([])

  const { data, isFetching } = useGetAllProductTagsQuery(
    { ...queryParam },
    {
      skip: !open,
    },
  )

  useEffect(() => {
    if (open) {
      setTags(selectedTags)
    }
  }, [open])

  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={() => {
        onCloseCallback && onCloseCallback()
        setQueryParam(defaultquery)
        setTags(selectedTags)
      }}
      title="Select Tags"
      childrenClassName="md:!max-w-[420px]"
    >
      <div
        className="
        h-screen max-h-[500px]
        flex flex-col gap-2
      "
      >
        <SearchInput
          searchFunction={(search) => {
            setQueryParam({
              ...queryParam,
              search: search === '' ? undefined : search,
              skip: 0,
            })
          }}
          placeholder="Search tags"
          className="!max-w-full"
        />

        {/* Tags  */}
        <div className="flex-1 overflow-y-scroll">
          {isFetching ? (
            <div className="w-full flex justify-center pt-10">
              <LoadingOval
                loaderWidth="25"
                loaderHeight="25"
                color={PRIMARY_COLOR}
              />
            </div>
          ) : (
            <div>
              {data?.data?.data?.length && data?.data?.data?.length > 0 ? (
                <div className="flex flex-col">
                  {data?.data?.data
                    ?.filter((t) => t.isActive)
                    ?.map((tag, idx) => {
                      return (
                        <Checkbox
                          checkStatus={tags
                            .map((tag) => tag._id)
                            .includes(tag._id)}
                          handleChange={(checked) => {
                            if (checked) {
                              const tagsCopy: Tag[] = JSON.parse(
                                JSON.stringify(tags),
                              )
                              tagsCopy.push(tag)

                              setTags(tagsCopy)
                            } else {
                              const tagsCopy: Tag[] = JSON.parse(
                                JSON.stringify(tags),
                              )
                              setTags(
                                tagsCopy.filter(
                                  (singleTag) => tag._id !== singleTag._id,
                                ),
                              )
                            }
                          }}
                          text={tag.name}
                          textPosition="right"
                          className="
                        py-3 border-b last:border-b-0
                        w-full
                        "
                          key={tag._id}
                        />
                      )
                    })}
                </div>
              ) : (
                <EmptyState text="No tags found" />
              )}
            </div>
          )}
        </div>

        <Button
          type="button"
          primary
          label="Continue"
          onClick={() => {
            onSuccessCallback && onSuccessCallback(tags)
          }}
          className="sticky bottom-0"
        />
      </div>
    </ModalComponent>
  )
}
